import { TitleLarge500, TitleXLarge500 } from '@nebula/global-styles';
import styled from 'styled-components';

export const PageTitleContainer = styled.div`
  display: flex;
  > ${TitleLarge500} {
    margin-top: 0;
    margin-bottom: 12px;
  }
  > ${TitleXLarge500} {
    margin-top: 0;
    margin-bottom: 20px;
  }
`;
